/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/ng2-semantic-ui/components/popup/popup.ngfactory';
import * as i4 from './components/login/login.component.ngfactory';
import * as i5 from './components/signup/signup.component.ngfactory';
import * as i6 from './components/map/map.component.ngfactory';
import * as i7 from './components/body-parts/body-parts.component.ngfactory';
import * as i8 from './components/book-visit/book-visit.component.ngfactory';
import * as i9 from './components/privacy-policy/privacy-policy.component.ngfactory';
import * as i10 from './components/booking-success/booking-success.component.ngfactory';
import * as i11 from './components/profile/profile.component.ngfactory';
import * as i12 from './components/bookings/bookings.component.ngfactory';
import * as i13 from './components/offer-booking-fisiq/offer-booking-fisiq.component.ngfactory';
import * as i14 from './components/forgot-password/forgot-password.component.ngfactory';
import * as i15 from './components/reset-password/reset-password.component.ngfactory';
import * as i16 from './components/welcome/welcome.component.ngfactory';
import * as i17 from './components/expert/expert.component.ngfactory';
import * as i18 from './components/service/service.component.ngfactory';
import * as i19 from './app.component.ngfactory';
import * as i20 from '@angular/common';
import * as i21 from '@angular/platform-browser';
import * as i22 from '@angular/animations/browser';
import * as i23 from '@angular/platform-browser/animations';
import * as i24 from '@angular/forms';
import * as i25 from '@angular/http';
import * as i26 from '@angular/animations';
import * as i27 from '@angular/router';
import * as i28 from '../../app/helper';
import * as i29 from '../../app/services/guard.service';
import * as i30 from '../../app/services/main.service';
import * as i31 from '../../app/services/users.service';
import * as i32 from '../../app/services/bookings.service';
import * as i33 from '../../app/components/login/login.component';
import * as i34 from 'ng2-semantic-ui/components/collapse/collapse.module';
import * as i35 from 'ng2-semantic-ui/components/transition/transition.module';
import * as i36 from 'ng2-semantic-ui/components/accordion/accordion.module';
import * as i37 from 'ng2-semantic-ui/components/checkbox/checkbox.module';
import * as i38 from 'ng2-semantic-ui/components/dimmer/dimmer.module';
import * as i39 from 'ng2-semantic-ui/components/dropdown/dropdown.module';
import * as i40 from 'ng2-semantic-ui/components/message/message.module';
import * as i41 from 'ng2-semantic-ui/components/popup/popup.module';
import * as i42 from 'ng2-semantic-ui/components/progress/progress.module';
import * as i43 from 'ng2-semantic-ui/components/rating/rating.module';
import * as i44 from 'ng2-semantic-ui/components/search/search.module';
import * as i45 from 'ng2-semantic-ui/components/select/select.module';
import * as i46 from 'ng2-semantic-ui/components/sidebar/sidebar.module';
import * as i47 from 'ng2-semantic-ui/components/tabs/tab.module';
import * as i48 from 'ng2-semantic-ui/components/sui.module';
import * as i49 from 'mydatepicker/dist/my-date-picker.module';
import * as i50 from '../../app/components/signup/signup.component';
import * as i51 from '../../app/components/map/map.component';
import * as i52 from '../../app/components/body-parts/body-parts.component';
import * as i53 from '../../app/components/book-visit/book-visit.component';
import * as i54 from '../../app/components/privacy-policy/privacy-policy.component';
import * as i55 from '../../app/components/booking-success/booking-success.component';
import * as i56 from '../../app/components/profile/profile.component';
import * as i57 from '../../app/components/bookings/bookings.component';
import * as i58 from '../../app/components/offer-booking-fisiq/offer-booking-fisiq.component';
import * as i59 from '../../app/components/forgot-password/forgot-password.component';
import * as i60 from '../../app/components/reset-password/reset-password.component';
import * as i61 from '../../app/components/welcome/welcome.component';
import * as i62 from '../../app/components/expert/expert.component';
import * as i63 from '../../app/components/service/service.component';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.SuiPopupNgFactory,i4.LoginComponentNgFactory,i5.SignupComponentNgFactory,
              i6.MapComponentNgFactory,i7.BodyPartsComponentNgFactory,i8.BookVisitComponentNgFactory,
              i9.PrivacyPolicyComponentNgFactory,i10.BookingSuccessComponentNgFactory,
              i11.ProfileComponentNgFactory,i12.BookingsComponentNgFactory,i13.OfferBookingFisiqComponentNgFactory,
              i14.ForgotPasswordComponentNgFactory,i15.ResetPasswordComponentNgFactory,
              i16.WelcomeComponentNgFactory,i17.ExpertComponentNgFactory,i18.ServiceComponentNgFactory,
              i19.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i20.NgLocalization,
              i20.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,
              ([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,([] as any[])),
          i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),i0.ɵmpd(4608,i21.DomSanitizer,
              i21.ɵe,[i20.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i21.DomSanitizer]),
          i0.ɵmpd(4608,i21.HAMMER_GESTURE_CONFIG,i21.HammerGestureConfig,([] as any[])),
          i0.ɵmpd(5120,i21.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i21.ɵDomEventsPlugin(p0_0),new i21.ɵKeyEventsPlugin(p1_0),
                new i21.ɵHammerGesturesPlugin(p2_0,p2_1)];
          },[i20.DOCUMENT,i20.DOCUMENT,i20.DOCUMENT,i21.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i21.EventManager,i21.EventManager,[i21.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i21.ɵDomSharedStylesHost,i21.ɵDomSharedStylesHost,[i20.DOCUMENT]),
          i0.ɵmpd(4608,i21.ɵDomRendererFactory2,i21.ɵDomRendererFactory2,[i21.EventManager,
              i21.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i22.AnimationDriver,i23.ɵc,([] as any[])),
          i0.ɵmpd(5120,i22.ɵAnimationStyleNormalizer,i23.ɵd,([] as any[])),i0.ɵmpd(4608,
              i22.ɵAnimationEngine,i23.ɵb,[i22.AnimationDriver,i22.ɵAnimationStyleNormalizer]),
          i0.ɵmpd(5120,i0.RendererFactory2,i23.ɵe,[i21.ɵDomRendererFactory2,i22.ɵAnimationEngine,
              i0.NgZone]),i0.ɵmpd(6144,i21.ɵSharedStylesHost,(null as any),[i21.ɵDomSharedStylesHost]),
          i0.ɵmpd(4608,i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i21.Meta,
              i21.Meta,[i20.DOCUMENT]),i0.ɵmpd(4608,i21.Title,i21.Title,[i20.DOCUMENT]),
          i0.ɵmpd(4608,i24.ɵi,i24.ɵi,([] as any[])),i0.ɵmpd(4608,i25.BrowserXhr,i25.BrowserXhr,
              ([] as any[])),i0.ɵmpd(4608,i25.ResponseOptions,i25.BaseResponseOptions,
              ([] as any[])),i0.ɵmpd(5120,i25.XSRFStrategy,i25.ɵb,([] as any[])),i0.ɵmpd(4608,
              i25.XHRBackend,i25.XHRBackend,[i25.BrowserXhr,i25.ResponseOptions,i25.XSRFStrategy]),
          i0.ɵmpd(4608,i25.RequestOptions,i25.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i25.Http,i25.ɵc,[i25.XHRBackend,i25.RequestOptions]),i0.ɵmpd(4608,i26.AnimationBuilder,
              i23.ɵBrowserAnimationBuilder,[i0.RendererFactory2,i21.DOCUMENT]),i0.ɵmpd(5120,
              i27.ActivatedRoute,i27.ɵf,[i27.Router]),i0.ɵmpd(4608,i27.NoPreloading,
              i27.NoPreloading,([] as any[])),i0.ɵmpd(6144,i27.PreloadingStrategy,
              (null as any),[i27.NoPreloading]),i0.ɵmpd(135680,i27.RouterPreloader,
              i27.RouterPreloader,[i27.Router,i0.NgModuleFactoryLoader,i0.Compiler,
                  i0.Injector,i27.PreloadingStrategy]),i0.ɵmpd(4608,i27.PreloadAllModules,
              i27.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i27.ROUTER_INITIALIZER,
              i27.ɵi,[i27.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i27.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i28.Helper,i28.Helper,([] as any[])),
          i0.ɵmpd(4608,i29.GuardService,i29.GuardService,[i27.Router,i28.Helper]),
          i0.ɵmpd(4608,i30.MainService,i30.MainService,[i25.Http,i28.Helper,i27.ActivatedRoute]),
          i0.ɵmpd(4608,i31.UsersService,i31.UsersService,[i25.Http,i28.Helper]),i0.ɵmpd(4608,
              i32.BookingsService,i32.BookingsService,[i25.Http,i28.Helper,i27.ActivatedRoute,
                  i30.MainService]),i0.ɵmpd(4608,i33.LoginComponent,i33.LoginComponent,
              [i27.ActivatedRoute,i27.Router,i28.Helper,i30.MainService,i31.UsersService,
                  i32.BookingsService]),i0.ɵmpd(512,i20.CommonModule,i20.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i21.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i27.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i27.ɵg,i27.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i21.ɵc(p0_0,p0_1),i27.ɵh(p1_0)];
              },[[2,i21.NgProbeToken],[2,i0.NgProbeToken],i27.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i21.BrowserModule,i21.BrowserModule,[[3,i21.BrowserModule]]),
          i0.ɵmpd(512,i24.ɵba,i24.ɵba,([] as any[])),i0.ɵmpd(512,i24.FormsModule,i24.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i25.HttpModule,i25.HttpModule,([] as any[])),
          i0.ɵmpd(512,i34.SuiCollapseModule,i34.SuiCollapseModule,([] as any[])),i0.ɵmpd(512,
              i35.SuiTransitionModule,i35.SuiTransitionModule,([] as any[])),i0.ɵmpd(512,
              i36.SuiAccordionModule,i36.SuiAccordionModule,([] as any[])),i0.ɵmpd(512,
              i37.SuiCheckboxModule,i37.SuiCheckboxModule,([] as any[])),i0.ɵmpd(512,
              i38.SuiDimmerModule,i38.SuiDimmerModule,([] as any[])),i0.ɵmpd(512,i39.SuiDropdownModule,
              i39.SuiDropdownModule,([] as any[])),i0.ɵmpd(512,i40.SuiMessageModule,
              i40.SuiMessageModule,([] as any[])),i0.ɵmpd(512,i41.SuiPopupModule,i41.SuiPopupModule,
              ([] as any[])),i0.ɵmpd(512,i42.SuiProgressModule,i42.SuiProgressModule,
              ([] as any[])),i0.ɵmpd(512,i43.SuiRatingModule,i43.SuiRatingModule,([] as any[])),
          i0.ɵmpd(512,i44.SuiSearchModule,i44.SuiSearchModule,([] as any[])),i0.ɵmpd(512,
              i45.SuiSelectModule,i45.SuiSelectModule,([] as any[])),i0.ɵmpd(512,i46.SuiSidebarModule,
              i46.SuiSidebarModule,([] as any[])),i0.ɵmpd(512,i47.SuiTabsModule,i47.SuiTabsModule,
              ([] as any[])),i0.ɵmpd(512,i48.SuiModule,i48.SuiModule,([] as any[])),
          i0.ɵmpd(512,i49.MyDatePickerModule,i49.MyDatePickerModule,([] as any[])),
          i0.ɵmpd(512,i23.BrowserAnimationsModule,i23.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(1024,i27.ɵa,i27.ɵd,[[3,i27.Router]]),i0.ɵmpd(512,i27.UrlSerializer,
              i27.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,i27.ChildrenOutletContexts,
              i27.ChildrenOutletContexts,([] as any[])),i0.ɵmpd(256,i27.ROUTER_CONFIGURATION,
              {},([] as any[])),i0.ɵmpd(1024,i20.LocationStrategy,i27.ɵc,[i20.PlatformLocation,
              [2,i20.APP_BASE_HREF],i27.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i20.Location,
              i20.Location,[i20.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i27.ROUTES,
              () => {
                return [[{pathMatch:'full',path:'',component:i33.LoginComponent},{pathMatch:'full',
                    path:'login',component:i33.LoginComponent},{pathMatch:'full',path:'signup',
                    component:i50.SignupComponent},{pathMatch:'full',path:'find-clinic',
                    component:i51.MapComponent},{pathMatch:'full',path:'body-parts',
                    component:i52.BodyPartsComponent},{pathMatch:'full',path:'booking-visit',
                    component:i53.BookVisitComponent},{pathMatch:'full',path:'privacy-policy',
                    component:i54.PrivacyPolicyComponent},{pathMatch:'full',path:'booking-success/:id',
                    component:i55.BookingSuccessComponent,canActivate:[i29.GuardService]},
                    {pathMatch:'full',path:'profile',component:i56.ProfileComponent,
                        canActivate:[i29.GuardService]},{pathMatch:'full',path:'bookings',
                        component:i57.BookingsComponent,canActivate:[i29.GuardService]},
                    {pathMatch:'full',path:'test',component:i57.BookingsComponent,
                        canActivate:[i29.GuardService]},{pathMatch:'full',path:'offer-fysiq',
                        component:i58.OfferBookingFisiqComponent,canActivate:[i29.GuardService]},
                    {pathMatch:'full',path:'forgot-password',component:i59.ForgotPasswordComponent},
                    {pathMatch:'full',path:'reset-password',component:i60.ResetPasswordComponent},
                    {pathMatch:'full',path:'welcome',component:i61.WelcomeComponent,
                        canActivate:[i29.GuardService]},{pathMatch:'full',path:'expert',
                        component:i62.ExpertComponent,canActivate:[i29.GuardService]},
                    {pathMatch:'full',path:'service',component:i63.ServiceComponent,
                        canActivate:[i29.GuardService]}]];
              },([] as any[])),i0.ɵmpd(1024,i27.Router,i27.ɵe,[i0.ApplicationRef,i27.UrlSerializer,
              i27.ChildrenOutletContexts,i20.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i27.ROUTES,i27.ROUTER_CONFIGURATION,[2,i27.UrlHandlingStrategy],
              [2,i27.RouteReuseStrategy]]),i0.ɵmpd(512,i27.RouterModule,i27.RouterModule,
              [[2,i27.ɵa],[2,i27.Router]]),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9hcHAubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts